import React, { useState } from 'react'
import { Panel, Rate } from 'rsuite'
import { Row, Col } from 'rsuite'
import scrollToComponent from 'react-scroll-to-component'
import { useForm, Controller } from 'react-hook-form'
import ButtonPanel from '../ButtonPanel'
import InputForm from '../../components/forms/input/InputForm'

export default function AssessmentOfWorkingWithThaiHealthWidget(props) {
  const { showCommandButton, isEdit, onChangeIsEdit, isSubProject } = props
  const [section, setSection] = useState()
  const [isError, setIsError] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const [reservedWords, setReservedWords] = useState()
  const { register, handleSubmit, errors, control, setValue, clearErrors } = useForm()
  const [formSchema, setFormSchema] = useState(props.schema)

  const [hoverValue, setHoverValue] = useState(3)

  const onSubmit = (data) => {
    console.log('data', data)
  }

  const textStyle = {
    verticalAlign: 'top',
    lineHeight: '42px',
    display: 'inline-block',
  }

  return (
    <Panel
      shaded
      header={formSchema.header}
      collapsible
      defaultExpanded
      ref={(section) => {
        setSection(section)
      }}
    >
      {/* {isEdit && showCommandButton ? (
        <ProjectNameForm
          schema={formSchema}
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          setValue={setValue}
          clearErrors={clearErrors}
          reservedWords={reservedWords}
          setReservedWords={setReservedWords}
        />
      ) : (
        <ProjectNameView schema={formSchema} />
      )} */}
      <Panel>
        {formSchema.datas?.map((item, index) => {
          return (
            <>
              <Row>
                <Col>
                  {index + 1}. {item.label}
                </Col>
                <Col>
                  <Rate
                    size="lg"
                    defaultValue={3}
                    onChangeActive={(value) => {
                      console.log(value)
                    }}
                  />
                </Col>
              </Row>

              {/* <span style={textStyle}>{formSchema.rateData[hoverValue]}</span> */}
            </>
          )
        })}

        <InputForm
          schema={formSchema.otherIntroduce}
          rows={4}
          componentClass="textarea"
          register={register}
          Controller={Controller}
          control={control}
          errors={errors}
          setValue={setValue}
          clearErrors={clearErrors}
        />
      </Panel>

      {showCommandButton && (
        <>
          <hr />
          <ButtonPanel
            isDisabled={isLoading || reservedWords}
            isEdit={isEdit}
            isError={isError}
            buttonText={formSchema.buttonText || formSchema.header}
            onSave={handleSubmit(onSubmit)}
            // onCancel={() => {
            //   setIsError(false)
            //   onChangeIsEdit(!isEdit)
            // }}
            onEdit={() => {
              setIsError(false)
              onChangeIsEdit(!isEdit)
              scrollToComponent(section, { offset: 0, align: 'top', duration: 500 })
            }}
          />
        </>
      )}
    </Panel>
  )
}
